import { Component } from '@angular/core';
import { ToasterService } from '../service';

@Component({
    selector: 'ef-toaster-presenter',
    templateUrl: './toaster-presenter.component.html',
    styleUrls: ['./toaster-presenter.component.scss'],
    standalone: false
})
export class ToasterPresenter {
    constructor(private toaster: ToasterService) {}
    clearToast() {
        this.toaster.clear('ef-global-toast');
    }
}
